module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "main-content clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 table-filter"
  }, [_c('div', {
    staticClass: "row p-b-sm"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("发送邀请 ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary right m-r-sm upload-btn",
    attrs: {
      "type": "button",
      "id": "upload-resume-btn"
    }
  }, [_vm._v("导入简历")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-primary right m-r-sm",
    attrs: {
      "href": "/assets/tpls/resume-tpl.xlsx",
      "download": "resume.xlsx",
      "target": "_blank"
    }
  }, [_vm._v("下载模板")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary right m-r-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.batchInvites()
      }
    }
  }, [_vm._v("批量邀请")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-b-sm"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("所在部门：")]), _vm._v(" "), _vm._l((_vm.filter.pids), function(parent, indexd) {
    return _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parent.selected),
        expression: "parent.selected"
      }],
      key: indexd,
      staticClass: "select input-sm m-r-xs",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          parent.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.selectParent($event, indexd)
        }]
      }
    }, [_vm._v(">\n              "), _vm._l((parent.options), function(p) {
      return _c('option', {
        key: p._id,
        domProps: {
          "value": p._id
        }
      }, [_vm._v(_vm._s(p.name))])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row m-b-sm"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("测评岗位：")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.filter.questionnaire_post),
      expression: "filter.questionnaire_post",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input-sm",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter.questionnaire_post = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部岗位")]), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('option', {
      key: post._id,
      domProps: {
        "value": post._id
      }
    }, [_vm._v(_vm._s(post.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("就职状态：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.filter.tag),
      expression: "filter.tag",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "tag",
      "value": "0",
      "id": "tag-all"
    },
    domProps: {
      "checked": _vm._q(_vm.filter.tag, _vm._n("0"))
    },
    on: {
      "__c": function($event) {
        _vm.filter.tag = _vm._n("0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tag-all"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.filter.tag),
      expression: "filter.tag",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "tag",
      "value": "1",
      "id": "tag-finish"
    },
    domProps: {
      "checked": _vm._q(_vm.filter.tag, _vm._n("1"))
    },
    on: {
      "__c": function($event) {
        _vm.filter.tag = _vm._n("1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tag-finish"
    }
  }, [_vm._v("未入职")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.filter.tag),
      expression: "filter.tag",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "tag",
      "value": "2",
      "id": "tag-send"
    },
    domProps: {
      "checked": _vm._q(_vm.filter.tag, _vm._n("2"))
    },
    on: {
      "__c": function($event) {
        _vm.filter.tag = _vm._n("2")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tag-send"
    }
  }, [_vm._v("入职")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.filter.tag),
      expression: "filter.tag",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "tag",
      "value": "3",
      "id": "tag-send"
    },
    domProps: {
      "checked": _vm._q(_vm.filter.tag, _vm._n("3"))
    },
    on: {
      "__c": function($event) {
        _vm.filter.tag = _vm._n("3")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tag-send"
    }
  }, [_vm._v("不考虑")])])]), _vm._v(" "), _c('div', {
    staticClass: "row p-b-sm"
  }, [_c('div', {
    staticClass: " col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-9"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("邀请状态：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.filter.status),
      expression: "filter.status",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "0",
      "id": "status-all"
    },
    domProps: {
      "checked": _vm._q(_vm.filter.status, _vm._n("0"))
    },
    on: {
      "__c": function($event) {
        _vm.filter.status = _vm._n("0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status-all"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.filter.status),
      expression: "filter.status",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "3",
      "id": "status-finish"
    },
    domProps: {
      "checked": _vm._q(_vm.filter.status, _vm._n("3"))
    },
    on: {
      "__c": function($event) {
        _vm.filter.status = _vm._n("3")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status-finish"
    }
  }, [_vm._v("已测评")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.filter.status),
      expression: "filter.status",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "2",
      "id": "status-send"
    },
    domProps: {
      "checked": _vm._q(_vm.filter.status, _vm._n("2"))
    },
    on: {
      "__c": function($event) {
        _vm.filter.status = _vm._n("2")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status-send"
    }
  }, [_vm._v("已发送")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.filter.status),
      expression: "filter.status",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "1",
      "id": "status-new"
    },
    domProps: {
      "checked": _vm._q(_vm.filter.status, _vm._n("1"))
    },
    on: {
      "__c": function($event) {
        _vm.filter.status = _vm._n("1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status-new"
    }
  }, [_vm._v("未发送")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.filter.status),
      expression: "filter.status",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "-2",
      "id": "status-effective"
    },
    domProps: {
      "checked": _vm._q(_vm.filter.status, _vm._n("-2"))
    },
    on: {
      "__c": function($event) {
        _vm.filter.status = _vm._n("-2")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status-new"
    }
  }, [_vm._v("已过期")])]), _vm._v(" "), (_vm.user.category === 2) ? _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.filter.isMy),
      expression: "filter.isMy",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "checkbox",
      "true-value": 1,
      "false-value": 0,
      "id": "status-new"
    },
    domProps: {
      "checked": Array.isArray(_vm.filter.isMy) ? _vm._i(_vm.filter.isMy, null) > -1 : _vm._q(_vm.filter.isMy, 1)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.filter.isMy,
          $$el = $event.target,
          $$c = $$el.checked ? (1) : (0);
        if (Array.isArray($$a)) {
          var $$v = _vm._n(null),
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.filter.isMy = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.filter.isMy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.filter.isMy = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status-new"
    }
  }, [_vm._v("只看我的")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9 col-xs-12 n-p-r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.filter.search),
      expression: "filter.search",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input input-sm",
    attrs: {
      "type": "text",
      "placeholder": "输入姓名、手机号进行搜索",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.filter.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.reload()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter.search = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary col-xs-12",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reload()
      }
    }
  }, [_vm._v("搜索")])])])])])]), _vm._v(" "), (_vm.loading === 1) ? _c('loading', {
    staticClass: "col-xs-12"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === 0),
      expression: "loading === 0"
    }],
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-border"
  }, [_c('thead', [_c('tr', [_c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select_all),
      expression: "select_all"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": 1,
      "false-value": 0
    },
    domProps: {
      "checked": Array.isArray(_vm.select_all) ? _vm._i(_vm.select_all, null) > -1 : _vm._q(_vm.select_all, 1)
    },
    on: {
      "click": function($event) {
        _vm.toggleSelectAll()
      },
      "__c": function($event) {
        var $$a = _vm.select_all,
          $$el = $event.target,
          $$c = $$el.checked ? (1) : (0);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.select_all = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.select_all = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.select_all = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("姓名")]), _vm._v(" "), _c('th', [_vm._v("联系方式")]), _vm._v(" "), _c('th', [_vm._v("部门")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filter.questionnaire_post === '-1'),
      expression: "filter.questionnaire_post === '-1'"
    }]
  }, [_vm._v("岗位")]), _vm._v(" "), _c('th', [_vm._v("综合得分")]), _vm._v(" "), _c('th', [_vm._v("邀请时间")]), _vm._v(" "), _c('th', [_vm._v("测评时间")]), _vm._v(" "), (_vm.user.category === 2 && _vm.filter.isMy === 0) ? _c('th', [_vm._v("HR")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invitations), function(invitation) {
    return _c('tr', {
      key: invitation._id
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (invitation.selected),
        expression: "invitation.selected"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": invitation.status !== 1 && invitation.status !== -2,
        "true-value": 1,
        "false-value": 0
      },
      domProps: {
        "checked": Array.isArray(invitation.selected) ? _vm._i(invitation.selected, null) > -1 : _vm._q(invitation.selected, 1)
      },
      on: {
        "click": function($event) {
          _vm.toggleSelectNode(invitation)
        },
        "__c": function($event) {
          var $$a = invitation.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (1) : (0);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (invitation.selected = $$a.concat($$v))
            } else {
              $$i > -1 && (invitation.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            invitation.selected = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [(invitation.status === 3) ? _c('router-link', {
      staticClass: "color-primary bold",
      attrs: {
        "to": {
          'name': 'EvaluateReport',
          params: {
            'code': invitation.evaluate_record.record || 'undefined'
          }
        },
        "target": "_blank",
        "title": "点击查看报告"
      }
    }, [_vm._v(_vm._s(invitation.realname))]) : _vm._e(), _vm._v(" "), (invitation.status !== 3) ? _c('span', [_vm._v(_vm._s(invitation.realname))]) : _vm._e(), _vm._v(" "), (invitation.status === 3) ? _c('span', {
      staticClass: "badge",
      class: {
        'bg-success': invitation.tag === 2, 'bg-warning': invitation.tag === 3
      }
    }, [_vm._v(_vm._s(invitation.tag === 1 ? '未入职' : (invitation.tag === 2 ? '入职' : '不考虑')))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(invitation.phone || invitation.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invitation.organization ? invitation.organization.name : '-'))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filter.questionnaire_post === '-1'),
        expression: "filter.questionnaire_post === '-1'"
      }]
    }, [_vm._v(_vm._s(invitation.questionnaire_post && (invitation.questionnaire_post.name)))]), _vm._v(" "), (invitation.status === 3) ? _c('td', [_vm._v(_vm._s(invitation.score.toFixed(2)))]) : _vm._e(), _vm._v(" "), (invitation.status !== 3) ? _c('td', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (invitation.status >= 2) ? _c('td', [_vm._v(_vm._s(_vm._f("format")(invitation.evaluate_record.invitate_time, 'YYYY-MM-DD', invitation.evaluate_record.invitate_time)))]) : _vm._e(), _vm._v(" "), (invitation.status < 2) ? _c('td', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (invitation.status === 3) ? _c('td', [_vm._v(_vm._s(_vm._f("format")(invitation.complete_at, 'YYYY-MM-DD', invitation.complete_at)))]) : _vm._e(), _vm._v(" "), (invitation.status !== 3) ? _c('td', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (_vm.user.category === 2 && _vm.filter.isMy === 0) ? _c('td', [_vm._v("\n                " + _vm._s(invitation.owner ? (invitation.owner.realname || '-') : '管理员') + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "btn btn-primary btn-xs",
      on: {
        "click": function($event) {
          _vm.show(invitation)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), (invitation.status === 1 || invitation.status === -2) ? _c('span', {
      staticClass: "btn  btn-danger btn-xs",
      on: {
        "click": function($event) {
          _vm.invite(invitation)
        }
      }
    }, [_vm._v("邀请")]) : _vm._e(), _vm._v(" "), (invitation.status === 3 && invitation.resume) ? _c('a', {
      staticClass: "btn btn-warning btn-xs",
      attrs: {
        "href": invitation.resume.is_convert === -1 ? invitation.resume.url : invitation.resume.url_convert,
        "target": "_blank"
      }
    }, [_vm._v("简历")]) : _vm._e(), _vm._v(" "), (invitation.status === 3) ? _c('router-link', {
      staticClass: "btn  btn-info btn-xs",
      attrs: {
        "to": {
          'name': 'EvaluateReport',
          params: {
            'code': invitation.evaluate_record.record || 'undefined'
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("报告")]) : _vm._e(), _vm._v(" "), (invitation.status === 3 && invitation.tag === 1) ? _c('span', {
      staticClass: "btn btn-xs btn-xs btn-success",
      on: {
        "click": function($event) {
          _vm.tagInivite(invitation)
        }
      }
    }, [_vm._v("标记")]) : _vm._e(), _vm._v(" "), (invitation.status === 3 && (_vm.selectPost === '-1' || _vm.selectPost === invitation.questionnaire_post._id)) ? _c('span', {
      staticClass: "btn btn-xs btn-xs",
      on: {
        "click": function($event) {
          _vm.addCompareResume(invitation)
        }
      }
    }, [_vm._v("对比")]) : _vm._e()], 1)])
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === 0),
      expression: "loading === 0"
    }],
    staticClass: "col-xs-12"
  }, [_c('pagination', {
    attrs: {
      "current": _vm.filter.current,
      "length": _vm.filter.length,
      "total": _vm.filter.total,
      "page-click": _vm.go
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.modal.edit) ? _c('div', [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n          " + _vm._s(_vm.modal.title) + "\n          "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.clearEdit()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body w-sm"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 text-right label p-t-b-sm n-p-r"
  }, [_vm._v("\n                  姓名:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.invitation.realname),
      expression: "invitation.realname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input input-md",
    attrs: {
      "type": "text",
      "placeholder": "姓名:风清扬",
      "readonly": _vm.modal.readonly
    },
    domProps: {
      "value": (_vm.invitation.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invitation.realname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 label p-t-b-sm n-p-l text-left"
  }, [_vm._v("\n                  *\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 text-right label p-t-b-sm n-p-r"
  }, [_vm._v("\n                  邮箱:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.invitation.email),
      expression: "invitation.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input input-md",
    attrs: {
      "type": "text",
      "placeholder": "邮箱:test@test.com",
      "readonly": _vm.modal.readonly
    },
    domProps: {
      "value": (_vm.invitation.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invitation.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 label p-t-b-sm n-p-l text-left"
  }, [_vm._v("\n                  *\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 text-right label p-t-b-sm n-p-r"
  }, [_vm._v("\n                  手机号:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.invitation.phone),
      expression: "invitation.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input input-md",
    attrs: {
      "type": "text",
      "placeholder": "手机号:18888888888",
      "readonly": _vm.modal.readonly
    },
    domProps: {
      "value": (_vm.invitation.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invitation.phone = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 label p-t-b-sm n-p-l text-left"
  }, [_vm._v("\n                  *\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 text-right label p-t-b-sm n-p-r"
  }, [_vm._v("\n                  岗位:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.invitation.questionnaire_post),
      expression: "invitation.questionnaire_post",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input-md col-xs-12",
    attrs: {
      "disabled": _vm.invitation._id
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.invitation.questionnaire_post = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部岗位")]), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('option', {
      key: post._id,
      domProps: {
        "value": post._id
      }
    }, [_vm._v(_vm._s(post.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 label p-t-b-sm n-p-l text-left"
  }, [_vm._v("\n                  *\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 text-right label p-t-b-sm n-p-r"
  }, [_vm._v("\n                  所在部门（院系）:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 clearfix"
  }, _vm._l((_vm.invitation.pids), function(parent, indexd) {
    return _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parent.selected),
        expression: "parent.selected"
      }],
      key: indexd,
      staticClass: "select input-md col-xs-12 m-b-sm",
      attrs: {
        "disabled": _vm.modal.readonly
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          parent.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.selectIParent($event, indexd)
        }]
      }
    }, _vm._l((parent.options), function(p) {
      return _c('option', {
        key: p._id,
        domProps: {
          "value": p._id
        }
      }, [_vm._v(_vm._s(p.name))])
    }))
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 label p-t-b-sm n-p-l text-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [(!_vm.modal.readonly) ? _c('div', {
    staticClass: "btn btn-primary m-r-md",
    on: {
      "click": function($event) {
        _vm.upsert()
      }
    }
  }, [_vm._v("发送邀请")]) : _vm._e(), _vm._v(" "), (!_vm.modal.readonly) ? _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.clearEdit()
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.modal.readonly) ? _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.clearEdit()
      }
    }
  }, [_vm._v("返回")]) : _vm._e()])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.modal.import) ? _c('div', [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n          " + _vm._s(_vm.modal.title) + "\n          "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.clearImport()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body w-sm",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-border"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("序号")]), _vm._v(" "), _c('th', [_vm._v("姓名")]), _vm._v(" "), _c('th', [_vm._v("邮箱")]), _vm._v(" "), _c('th', [_vm._v("手机号")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.import_invitations), function(invitation, ind) {
    return _c('tr', {
      key: invitation.email
    }, [_c('td', [_vm._v(_vm._s(ind + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invitation.realname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invitation.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invitation.phone))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-sm"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6 p-t-b-sm col-sm-3 text-right"
  }, [_vm._v("\n                岗位:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 clearfix col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.import_questionnaire_post),
      expression: "import_questionnaire_post",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input-md col-xs-12",
    attrs: {
      "disabled": _vm.invitation._id
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.import_questionnaire_post = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部岗位")]), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('option', {
      key: post._id,
      domProps: {
        "value": post._id
      }
    }, [_vm._v(_vm._s(post.name))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-sm"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6 p-t-b-sm col-sm-3 text-right"
  }, [_vm._v("\n                所在部门（院系）:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 clearfix col-sm-5"
  }, _vm._l((_vm.import_pids), function(parent, indexd) {
    return _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parent.selected),
        expression: "parent.selected"
      }],
      key: indexd,
      staticClass: "select input-md col-xs-12 m-b-sm",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          parent.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.selectImportParent($event, indexd)
        }]
      }
    }, _vm._l((parent.options), function(p) {
      return _c('option', {
        key: p._id,
        domProps: {
          "value": p._id
        }
      }, [_vm._v(_vm._s(p.name))])
    }))
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center m-t-b-sm"
  }, [_c('button', {
    staticClass: "btn btn-primary m-r-md",
    attrs: {
      "disabled": !_vm.import_btn_active
    },
    on: {
      "click": function($event) {
        _vm.importInvitations(0)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary m-r-md",
    attrs: {
      "disabled": !_vm.import_btn_active
    },
    on: {
      "click": function($event) {
        _vm.importInvitations(1)
      }
    }
  }, [_vm._v("保存并发送邀请")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.import_btn_active
    },
    on: {
      "click": function($event) {
        _vm.clearImport()
      }
    }
  }, [_vm._v("取消")])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.modal.batch) ? _c('div', [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n          " + _vm._s(_vm.modal.title) + "\n          "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.clearBatchInvite()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body w-sm",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('div', {
    staticClass: "row m-t-sm"
  }, [_c('div', {
    staticClass: "col-xs-12 p-t-b-sm"
  }, [_vm._v("\n              您一共选择了：\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "p-sm select-invitation-list"
  }, _vm._l((_vm.select_invitations), function(invite, index) {
    return _c('div', {
      key: invite._id,
      staticClass: "btn btn-sm m-r-xs m-b-xs",
      class: {
        'btn-primary': index % 5 === 0, 'btn-success': index % 5 === 1, 'btn-info': index % 5 === 2, 'btn-warning': index % 5 === 3,
      }
    }, [_vm._v(" " + _vm._s(invite.realname) + "-" + _vm._s(invite.questionnaire_post.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-t-b-sm"
  }, [_vm._v("\n              共 " + _vm._s(_vm.select_invitations.length) + "人。\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center m-t-b-sm"
  }, [_c('button', {
    staticClass: "btn btn-primary m-r-md",
    attrs: {
      "disabled": !_vm.batch_invite_btn_active
    },
    on: {
      "click": function($event) {
        _vm.batchInvitations(1)
      }
    }
  }, [_vm._v("发送邀请")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.batch_invite_btn_active
    },
    on: {
      "click": function($event) {
        _vm.clearBatchInvite()
      }
    }
  }, [_vm._v("取消")])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.modal.tag) ? _c('div', [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n          标记简历：" + _vm._s(_vm.tag_invite.name) + "\n          "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.closeTagSetting()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('div', {
    staticClass: "row m-t-sm text-center"
  }, [_c('div', {
    staticClass: "btn btn-sm m-r-sm",
    class: {
      'btn-success': _vm.tag_invite.tag === 2
    },
    on: {
      "click": function($event) {
        _vm.tag_invite.tag = 2
      }
    }
  }, [_vm._v("入职")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-sm",
    class: {
      'btn-success': _vm.tag_invite.tag === 3
    },
    on: {
      "click": function($event) {
        _vm.tag_invite.tag = 3
      }
    }
  }, [_vm._v("不考虑")])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-sm",
    staticStyle: {
      "border-bottom": "1px solid #888"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row m-t-sm"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-default m-r-sm col-xs-12 col-sm-6 right",
    attrs: {
      "disabled": !_vm.batch_invite_btn_active
    },
    on: {
      "click": function($event) {
        _vm.closeTagSetting()
      }
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-primary m-r-md col-xs-12 col-sm-6",
    attrs: {
      "disabled": !_vm.batch_invite_btn_active
    },
    on: {
      "click": function($event) {
        _vm.saveTag()
      }
    }
  }, [_vm._v("标记")])])])])])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h4', {
    staticClass: "table-name"
  }, [_vm._v("测评邀请")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60abb8e0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/invitation/list.vue
// module id = 483
// module chunks = 1